import { render, staticRenderFns } from "./ColorGradient.vue?vue&type=template&id=51a5a65c&"
import script from "./ColorGradient.vue?vue&type=script&lang=js&"
export * from "./ColorGradient.vue?vue&type=script&lang=js&"
import style0 from "./ColorGradient.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports